import Cookies from 'js-cookie'
import {getStore, setStore} from '@/utils/store'
import {doctor} from '@/utils/role'

const TokenKey = 'access_token'

export function getToken() {
  return Cookies.get(TokenKey) || getStore({name: TokenKey}) || ''
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

/**
 * 登录角色
 * @returns {*}
 */
export function getRoles() {
  return Cookies.get('roles') || getStore({name: 'roles'}) || doctor + ''
}

export function setRoles(roles) {
  setStore({
    name: 'roles',
    content: roles
  })
  return Cookies.set('roles', roles)
}

/**
 * 租户别名
 * @returns {*}
 */
export function getNameCode() {
  return Cookies.get('nameCode') || getStore({name: 'nameCode'}) || 'hfmx'
}

export function setNameCode(nameCode) {
  setStore({
    name: 'nameCode',
    content: nameCode
  })
  return Cookies.set('nameCode', nameCode)
}

export function getDoctorVersion() {
  return Cookies.get('doctorVersion') || getStore({name: 'doctorVersion'}) || ''
}

export function setDoctorVersion(version) {
  if (!version) {
    version = 'v1'
  }
  setStore({
    name: 'doctorVersion',
    content: version
  })
  return Cookies.set('doctorVersion', version)
}



// WEBPACK FOOTER //
// ./src/utils/cookie/index.js